
export const organizationType = {
    ADMIN: "admin",
    TRANSPORTER: "transporter",
  };
  